import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { VisualDeffectsService } from '../../../shared/services/viusal-deffects.service';
import { GetActiveVoucherDto } from '../../../shared/models/courier.models';
import { GetDeffectPositionsResponse, GetDeffectPositionsRequest } from '../../../shared/models/visual-deffects.models';
import { ActiveUserLocalDataService } from '../../../shared/services/active-user-local-data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'visual-damage-deffect-position-pick.component.html',
  styleUrls: ['./visual-damage-deffect-position-pick.component.scss']
})
export class VisualDamageDeffectPositionPickComponent implements OnInit {
  voucher: GetActiveVoucherDto | null = null;
  deffectPositionsResponse: GetDeffectPositionsResponse | null = null;
  type: string = '';
  loading: boolean = true;

  constructor(
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router,
    private visualDeffectsService: VisualDeffectsService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    const url = this.router.url;

    if (url.endsWith('/service-visual-damage-deffect-position-pick')) {
      this.voucher = this.activeUserLocalDataService.activeServiceVoucher;
    } else if (url.endsWith('/visual-damage-deffect-position-pick')) {
      this.voucher = this.activeUserLocalDataService.getActiveCourierVoucher();
    }

    if (!this.voucher) {
      this.router.navigate(['/voucher']);
      return;
    }

    this.type = this.activeUserLocalDataService.visualDamageType;
    this.activeUserLocalDataService.visualDamageType = '';

    const request: GetDeffectPositionsRequest = { carId: this.voucher.carsId };
    this.visualDeffectsService.getDeffectPositions(request).subscribe((response: GetDeffectPositionsResponse) => {
      this.deffectPositionsResponse = response;
      this.loading = false;
    }, error => {
      console.error('Error fetching deffect positions:', error);
      this.loading = false;
    });
  }

  ContinueNextStep(deffectPositionId: number, deffectName: string) {
    this.activeUserLocalDataService.visualDamageType = this.type;
    this.activeUserLocalDataService.visualDamageDeffectPositionId = deffectPositionId;
    this.activeUserLocalDataService.visualDamageDeffectPosition = deffectName;

    if (this.voucher?.isServiceVoucher) {
      this.router.navigate(['/service-visual-damage-post-damage']);
    } else {
      this.router.navigate(['/visual-damage-post-damage']);
    }
  }

  backClick() {
    this.activeUserLocalDataService.visualDamageType = this.type;

    if (this.voucher?.isServiceVoucher) {
      this.router.navigate(['/service-visual-damage-action-pick']);
    } else {
      this.router.navigate(['/visual-damage-action-pick']);
    }
  }

  getPageTitle(): string {
    if (this.type === 'd') {
      return this.translate.instant('VisualDamageOrDefectPosition');
    } else if (this.type === 'c') {
      return this.translate.instant('RoadTrafficAccidentDamageOrDefectPosition');
    } else {
      return this.translate.instant('IncorrectType');
    }
  }
}